import validator from 'validator';

import {VALIDATE_STRONG_PASSWORD, STRONG_PASSWORD_OPTIONS} from '../../assets/config'

export const validate_changePassword = (email, password, newPassword, repeatPassword, t) => {
  if (validator.isEmpty(email) || validator.isEmpty(password) || validator.isEmpty(newPassword) || validator.isEmpty(repeatPassword)) {
    return t('changePassword.fields_empty');
  } else {
    if (!validator.isEmail(email)) {
      return t('changePassword.email_invalid');
    }
    if (!validator.equals(newPassword, repeatPassword)) {
      return t('changePassword.no_equal_password');
    }

    if (VALIDATE_STRONG_PASSWORD && !validator.isStrongPassword(newPassword, STRONG_PASSWORD_OPTIONS)){
      return t('changePassword.password_rules');
    }

  }
  return '';
}
